export const getMetaField = () => {
	return {
		email: {
			label: 'E-mail',
			placeholder: 'Введите E-mail',
		},
		password: {
			label: 'Пароль',
			placeholder: 'Введите пароль',
		},
	};
};
